import { CatalogScreen } from '../features/catalog/CatalogScreen'

export function CatalogPage() {
  return <CatalogScreen />
}
